import React from "react";
import HelpIcon from '@material-ui/icons/Help';
import HomeIcon from "@material-ui/icons/Home";
import ImageIcon from "@material-ui/icons/Image";
import GradeIcon from '@material-ui/icons/Grade';
import ExploreIcon from '@material-ui/icons/Explore';
import SecurityIcon from "@material-ui/icons/Security";
import MenuBookIcon from '@material-ui/icons/MenuBook';
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import NotificationsIcon from '@material-ui/icons/Notifications';

export const UVT_LEFT_NAV_LIST = [
    {title: "Inicio", icon: <HomeIcon/>, redirectTo: "/"},
    // {title: "Simuladores", icon: <FlightIcon/>, redirectTo: "/simuladores"},
    {title: "Imágenes", icon: <ImageIcon/>, redirectTo: "/imagenes"},
    {title: "Anuncios", icon: <NotificationsIcon/>, redirectTo: "/anuncios"},
    {title: "Calificaciones", icon: <GradeIcon/>, redirectTo: "/calificaciones"},
    {title: "Material Apoyo", icon: <LocalLibraryIcon/>, redirectTo: "/apoyo"},
    {title: "Plan de Estudios", icon: <ExploreIcon/>, redirectTo: "/materias"},
    {title: "Biblioteca", icon: <MenuBookIcon/>, redirectTo: "/biblioteca"},
    {title: "Privacidad", icon: <SecurityIcon/>, redirectTo: "/privacidad"},
    {title: "Soporte", icon: <HelpIcon/>, redirectTo: "/soporte"},
    // {title: "Materias", icon: <ListIcon/>, redirectTo: "/materias"},
];
